module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/smoothie_25407e.jpg";